/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Settings_Teams_Member_CountInputs */

const cs_settings_teams_member_count = /** @type {(inputs: Settings_Teams_Member_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} členů`)
};

const en_settings_teams_member_count = /** @type {(inputs: Settings_Teams_Member_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} members`)
};

/**
* | output |
* | --- |
* | "{count} members" |
*
* @param {Settings_Teams_Member_CountInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_teams_member_count = /** @type {((inputs: Settings_Teams_Member_CountInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Teams_Member_CountInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_teams_member_count(inputs)
	return cs_settings_teams_member_count(inputs)
});